'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  margin-right: 6px;\n  margin-top: 3px;\n  display: inline-block;\n  vertical-align: top;\n'], ['\n  margin-right: 6px;\n  margin-top: 3px;\n  display: inline-block;\n  vertical-align: top;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icon = require('@hixme-ui/icon');

var _icon2 = _interopRequireDefault(_icon);

var _text = require('@hixme-ui/text');

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintLabel = _styledComponents2.default.span(_templateObject);

var handleClick = function handleClick(e) {
  e.preventDefault();
  window.print();
};

var Print = function Print(_ref) {
  var showIcon = _ref.showIcon,
      showLabel = _ref.showLabel,
      label = _ref.label;
  return _react2.default.createElement(
    _text2.default,
    {
      cursor: 'pointer',
      light: true,
      onClick: handleClick
    },
    showLabel && _react2.default.createElement(
      PrintLabel,
      null,
      label
    ),
    showIcon && _react2.default.createElement(_icon2.default, { printer: true, fontSize: 22, light: true, style: { verticalAlign: 'middle' } })
  );
};

Print.propTypes = {
  label: _propTypes2.default.string,
  showIcon: _propTypes2.default.bool,
  showLabel: _propTypes2.default.bool
};

Print.defaultProps = {
  label: 'Print',
  showIcon: true,
  showLabel: true
};

Print.displayName = 'hui:Print';
Print.huiName = 'Print';

exports.default = Print;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../print/lib/index.js
// module id = 744
// module chunks = 0